// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LPeX","toggleWrap":"styles_toggleWrap__SieDH","content":"styles_content__FqoJE","selectAreaCode":"styles_selectAreaCode__1XXPr"};